import {Styles} from 'appearance'
import {useState, useMemo, useWindowSize, useEffect} from 'services/hooks'
import {useI18n} from 'store/Store'

let lastSizeWidth = 0

const UsePage = ({noDrawer}) => {
    const {i18n} = useI18n()
    const windowSize = useWindowSize()

    const [drawerOpen, setDrawerOpen] = useState(false)

    const toggleDrawer = () => {
        setDrawerOpen((prev) => !prev)
    }

    const closeDrawer = () => {
        setDrawerOpen(false)
    }

    const marginStart = useMemo(() => {
        if (noDrawer) {
            return 0
        } else if (drawerOpen) {
            return Styles.DRAWER_WIDTH
        }
        return Styles.DRAWER_WIDTH_CLOSED
    }, [drawerOpen, noDrawer])

    const dir = i18n.t('dir')
    useEffect(() => {
        if (lastSizeWidth !== windowSize.width) {
            lastSizeWidth = windowSize.width
            drawerOpen && setDrawerOpen(false)
        }
    }, [drawerOpen, windowSize.width])
    return {drawerOpen, toggleDrawer, closeDrawer, dir, marginStart}
}

export default UsePage
